import Input from "../../components/Input/Input";
import { useContextTranslate } from "../../components/Translate/ContextProvider";
import { Container } from "../../components";
import { usePOST } from "../../Tools/APIs";
import { useEffect } from "react";
import Loading from "../../Tools/Loading";
function ForgetPassword() {
  const { content } = useContextTranslate();
  const { handleSubmit, error, loading, handleChangeInput, formData } = usePOST(
    {}
  );
  const handleSubmitMain = (e) => {
    e.preventDefault();
    handleSubmit("send/verification-code", "/verification-code");
  };
  useEffect(() => {
    sessionStorage.setItem("email", formData?.email);
  }, [formData]);
  return (
    <Container>
      <div className="w-1/2 max-lg:w-full mx-auto bg-gradient-to-t from-[#E00201] to-[#062371] p-2 rounded-2xl overflow-hidden my-10">
        <div className="bg-gray-200 flex flex-col justify-center space-y-6 border border-Blu sm:p-10 max-sm:p-4 rounded-2xl">
          <h1 className="text-2xl font-semibold max-xsm:text-lg">
            {content.ForgerPassword}
          </h1>
          <Input
            name="email"
            onChange={handleChangeInput}
            title={content.EnterYourUserNameOrPhone}
          />
          {loading ? <Loading /> : ""}
          <div className="text-red-600">{error}</div>
          <div className="w-fit mx-auto">
            <button
              className="border px-10 border-Main hover:text-white text-Main hover:bg-Main bg-white font-semibold p-3 rounded-xl"
              type="submit"
              onClick={handleSubmitMain}
            >
              {content.continued}
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
}
export default ForgetPassword;
